import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import RenderEventTypeCards from './components/RenderEventTypeCards'
import RenderGenericCards from './components/RenderGenericCards'
import { DASHBOARD, EVENTS, FEATURED, GENERAL_EVENTS, SPORT_EVENTS } from 'constants/appConstants'
// import { getList, getEventsTypeList, getEventsList } from 'services/content-service'
import { getRelatedContentArray } from 'utils/relatedContent'
import * as S from './styled'

const ListGrid = ({ itemHeight, contentType, related, content, handleStatus, items, isSearch }) => {
  const [gridItems, setGridItems] = useState([])

  useEffect(() => {
    if (related && contentType !== EVENTS) {
      setGridItems(getRelatedContentArray(content, items, 4))
    }
  }, [content])

  useEffect(() => {
    if (!related) setGridItems(items)
  }, [items])

  useEffect(() => {
    if (isSearch) setGridItems(items)
  }, [isSearch, items])

  return (
    <>
      <S.Grid contentType={contentType}>
        {gridItems?.length > 0 &&
          (contentType === DASHBOARD ||
            contentType === EVENTS ||
            contentType === SPORT_EVENTS ||
            contentType === GENERAL_EVENTS) &&
          gridItems.map(item => (
            <RenderEventTypeCards
              key={`${item.contentType}_${item.documentId}`}
              item={item}
              itemHeight={itemHeight}
              handleStatus={handleStatus}
              contentType={contentType}
            />
          ))}

        {gridItems?.length > 0 &&
          contentType !== EVENTS &&
          contentType !== DASHBOARD &&
          contentType !== SPORT_EVENTS &&
          contentType !== GENERAL_EVENTS &&
          gridItems.map(item => (
            <RenderGenericCards
              item={item}
              key={`${item.contentType}_${item.documentId}`}
              contentType={contentType}
              itemHeight={itemHeight}
              featured={contentType === FEATURED || false}
              handleStatus={handleStatus}
            />
          ))}
      </S.Grid>
    </>
  )
}

ListGrid.defaultProps = {
  itemHeight: '',
  contentType: '',
  related: false,
  content: {},
  handleStatus: () => {},
  isSearch: false,
  items: [],
}

ListGrid.propTypes = {
  itemHeight: PropTypes.string,
  contentType: PropTypes.string,
  related: PropTypes.bool,
  content: PropTypes.object,
  handleStatus: PropTypes.func,
  items: PropTypes.array,
  isSearch: PropTypes.bool,
}

export default ListGrid
